/* eslint-disable react/no-unescaped-entities */

const AboutUsIT = () => {
  return (
    <>
      <h1>Chi Siamo</h1>
      <h2>La Nostra Missione</h2>
      <div>
        In mind-r.ai, abbiamo intrapreso un viaggio per democratizzare l'accesso
        alle cure per la salute mentale. Crediamo nel potere della tecnologia
        come uno strumento per abbattere le barriere, cancellare i confini e
        rendere la terapia universalmente accessibile. Abbiamo visto gli effetti
        debilitanti che le condizioni di salute mentale non trattate possono
        avere su individui e società - tassi di incarcerazione in aumento, costi
        economici che raggiungono fino al 4% del PIL globale, e altro ancora. La
        nostra missione è cambiare questo scenario.
      </div>
      <div>
        Immaginiamo un mondo in cui tutti, indipendentemente dalla loro
        posizione, lingua, o stato economico, possono accedere al supporto
        terapeutico di cui hanno bisogno. Vogliamo normalizzare la ricerca di
        aiuto, ridurre lo stigma e creare un futuro in cui la priorità alla
        salute mentale è la norma, non l'eccezione. Il nostro obiettivo non è
        solo fornire un servizio. È avviare un movimento verso una migliore
        salute mentale per tutti.
      </div>
      <h2>L'Impatto Globale della Salute Mentale</h2>
      <div>
        I problemi di salute mentale gravano profondamente sul nostro mondo.
        Sono tra le principali cause di malattia e disabilità a livello
        mondiale, che colpiscono una persona su quattro in un qualche momento
        della loro vita
        <a
          href="https://www.who.int/news-room/fact-sheets/detail/mental-disorders"
          target="_blank"
        >
          [1]
        </a>
        . Gli esperti stimano che i problemi di salute mentale non trattati
        rappresentino il 13% dell'onere globale delle malattie
        <a
          href="https://www.who.int/news-room/fact-sheets/detail/mental-disorders"
          target="_blank"
        >
          [1]
        </a>
        .
      </div>
      <div>
        Le implicazioni economiche sono impressionanti. L'economia globale
        potrebbe perdere 16 trilioni di dollari entro il 2030 a causa di
        problemi di salute mentale dovuti alla diminuzione della produttività e
        all'aumento dei costi sanitari
        <a
          href="https://www.thelancet.com/commissions/global-mental-health"
          target="_blank"
        >
          [2]
        </a>
        . Gli individui con problemi di salute mentale non trattati spesso
        affrontano una ridotta qualità della vita, un rischio maggiore di
        problemi di salute fisica e tassi di disoccupazione più elevati.
      </div>
      <div>
        Oltre ai fattori economici, i problemi di salute mentale possono portare
        a livelli più alti di violenza e crimine. Fino al 90% dei prigionieri ha
        riscontrato problemi di salute mentale
        <a href="https://www.ncbi.nlm.nih.gov/books/NBK533137/" target="_blank">
          [3]
        </a>
        . Questi problemi contribuiscono anche a problemi sociali come la
        senzatetto e le famiglie spezzate.
      </div>
      <div>
        In mind-r.ai, siamo ben consapevoli dei vasti impatti dei problemi di
        salute mentale e siamo impegnati a far parte della soluzione.
        Democratizzando l'accesso alla terapia, miriamo ad alleviare l'onere
        della salute mentale un individuo alla volta. La nostra missione va
        oltre l'assistenza sanitaria; ci impegniamo a creare un mondo migliore,
        più comprensivo.
      </div>
      <h2>Il Nostro Approccio</h2>
      <div>
        Segniamo il nostro percorso verso la democratizzazione della terapia con
        l'innovazione e l'accessibilità. L'intelligenza artificiale alimenta la
        nostra strategia, e la utilizziamo per comprendere e soddisfare le
        esigenze e le circostanze di ogni individuo. Costruiamo algoritmi
        complessi per abbinare le preferenze degli utenti, creando esperienze
        uniche e personalizzate.
      </div>
      <div>
        Abbiamo forti credenze nel principio della tecnologia guidata
        dall'empatia. Progettiamo ogni caratteristica tenendo conto delle
        esigenze e delle esperienze degli utenti per integrare la terapia nella
        vita quotidiana. Il nostro approccio si concentra sull'inclusività,
        adattando le nostre soluzioni a tutti, indipendentemente dalla lingua,
        dalla posizione o dallo stato socioeconomico.
      </div>
      <div>
        Ad ogni passo, la nostra missione di rendere l'assistenza per la salute
        mentale universalmente accessibile ci guida. Il nostro impegno per
        questo obiettivo modella il nostro approccio, influenza le nostre
        decisioni e ci spinge verso la nostra visione.
      </div>
      <h2>Il Nostro Servizio</h2>
      <div>
        In mind-r.ai, abbiamo trasformato il concetto tradizionale di terapia
        fornendo una piattaforma basata sulla voce e guidata dall'IA. Incontra
        Solace, il nostro terapeuta IA, pronto ad ascoltare in qualsiasi
        momento, ovunque. Solace abbattere le barriere di tempo, lingua e
        geografia, offrendo tipo di terapia, durata, tema, lingua e persino
        accento secondo le preferenze dell'utente. La nostra offerta unica apre
        un mondo di risorse per la salute mentale a chiunque, in qualsiasi
        momento, ovunque.
      </div>
      <div>
        Come compagno adattabile, Solace adatta il suo approccio alle esigenze
        di ogni individuo. Dal fornire conversazioni profonde e introspettive
        all'offrire chiacchierate casuali e confortanti, Solace corrisponde agli
        stati d'animo e alle esigenze dei nostri utenti. La terapia dovrebbe
        essere tanto diversa e dinamica quanto le persone che la cercano.
      </div>
      <div>
        Dopo ogni sessione di terapia con Solace, generiamo un riassunto e
        azioni pratiche. Questi non sono solo rapporti; sono strumenti per
        potenziare l'apprendimento autonomo e l'autoriflessione. Anche se le
        conversazioni con Solace rimangono private e sicure, crediamo che ogni
        interazione dovrebbe portare a un'illuminazione, offrendo agli utenti la
        possibilità di riflettere su se stessi e sulla loro crescita.
      </div>
      <h2>Unisciti a Noi</h2>
      <div>
        Sei pronto a fare il primo passo verso una migliore salute mentale?
        Unisciti alla comunità di mind-r.ai oggi stesso ed esplora un nuovo
        approccio alla terapia. Incontra Solace, il tuo terapeuta IA, pronto ad
        ascoltare, capire e guidarti nel tuo percorso.
      </div>
    </>
  )
}
export default AboutUsIT
